<template>
  <section>
    <el-table
      :data="data"
      stripe
      border
      :header-cell-style="rowStyle()"
    >
      <el-table-column
        v-for="(item, index) in configs"
        :key="index"
        :label="item.label"
        :width="item.width"
        :align="item.align"
      >
        <template slot-scope="scope">
          <slot
            v-if="item.type == 'slot'"
            :row="scope.row"
            :name="item.model"
          />
          <div
            v-else
            :style="{
              cursor: item.model == isRouteDtoStr ? 'pointer' : 'auto',
            }"
            @click="handleRouteDto(scope.row, item.model)"
          >
            {{ scope.row[item.model] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
import mock from '@/utils/mock'
export default {
  name: 'ComTable',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    configs: {
      type: Array,
      default: () => {
        return []
      }
    },
    isRouteDto: {
      type: Boolean,
      default: false
    }, // 是否允许跳转到详情页
    isRouteDtoStr: {
      type: String,
      default: ''
    } // 允许跳转到详情页 的列名称
  },
  data() {
    return {
      systemInfo: mock.system.global.viewInfo
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleRouteDto(x, v) {
      if (this.isRouteDto) {
        this.$emit('path', x, v)
      }
    },
    rowStyle() {
      return this.systemInfo.tableHead
    }
  }
}
</script>
